module.exports = __webpack_public_path__ + "static/media/bullet.6a88076e.svg";